// Entry point for the build script in your package.json
import '@hotwired/turbo-rails'
import './controllers'
import './elements'
import 'form-request-submit-polyfill'
import { handleTurboStreamRender, handleLoadAction, handleTurboStreamRedirect } from './util/turbo-stream'
import { StreamActions } from '@hotwired/turbo'
import * as ActiveStorage from '@rails/activestorage'

import LocalTime from 'local-time'

LocalTime.start()

document.addEventListener('turbo:before-stream-render', handleTurboStreamRender)

// reload local-time instances after a page morph
document.addEventListener('turbo:morph', () => LocalTime.run())

StreamActions.load = function () {
  handleLoadAction(this)
}

// allow Turbo stream action to redirect to a given
StreamActions.redirect = function () {
  handleTurboStreamRedirect(this)
}

ActiveStorage.start()

// Prevent prefetching for modal links
document.addEventListener('turbo:before-prefetch', (event) => {
  const link = event.target
  const dataAction = link.getAttribute('data-action')

  if (dataAction && dataAction.includes('body#showModal')) {
    event.preventDefault()
  }
})
